import { sineOut } from 'svelte/easing'

export default function toLowerCase(node, { /*speed = 100*/ duration = 6000 }) {
	const prob = 0.01

	const valid = (
		node.childNodes.length === 1 &&
		node.childNodes[0].nodeType === Node.TEXT_NODE
	);

	if (!valid) {
		throw new Error(`This transition only works on elements with a single text node child`);
	}

	let text = node.textContent;
	let outputText = ""

	return {
		duration,
		tick: t => {

			const eased = sineOut(t)
			
			text = node.textContent
			outputText = ""
			
			for(var i = 0; i < text.length; i++){ 
				const char = text.slice(i, i+1)

				if(i == 0){ // title case, keep first letter uppercase
					outputText += char.toUpperCase()
					continue
				}

				if(!isNaN(char * 1)){ 
					// numeric character
					outputText += char
					continue
				}

				if(char == char.toLowerCase()){
					outputText += char
					continue
				}

				if(text.slice(i-1, i) == " "){ // new word, keep first letter capitalized for title case
					outputText += char
					continue
				}

				if(Math.random() > prob * eased){
					outputText += char
				} else {
					outputText += char.toLowerCase()
				}
			}
			node.textContent = outputText
		}
	};
}